import { faShareSquare } from "@fortawesome/pro-regular-svg-icons";
import { FontAwesomeIconProps } from "@fortawesome/react-fontawesome";
import React from "react";

import { Btn, BtnCountType, BtnLayout, BtnType } from "@/mk2/components/Btn";
import { SHARE_BUTTON_LABEL } from "@/mk/autogenerated/translation";

const farShareSquareLg: FontAwesomeIconProps = { icon: faShareSquare, size: "lg" };

interface OwnProps {
    className?: string;
    sharesCount: number;
    link?: string;
    hideLabel?: boolean;
}

type Props = OwnProps;

class ShareButton extends React.PureComponent<Props> {
    public render() {
        const { className, sharesCount, link, hideLabel } = this.props;

        return (
            <Btn
                className={className}
                layout={hideLabel ? BtnLayout.IconLabelCount : BtnLayout.CountIconLabel}
                type={BtnType.GreyText}
                count={sharesCount}
                countType={BtnCountType.Label}
                icon={farShareSquareLg}
                label={hideLabel ? undefined : SHARE_BUTTON_LABEL}
                link={link}
                linkRel="nofollow"
            />
        );
    }
}

export default ShareButton;
